import environment from "./env";

const muiPro = {
    key: "4160ffedbcc466c6f6717a361d01c466Tz0xMjA4NjksRT0xNzkyODg2Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
};

const sentryDsn =
    "https://66ce0f395bda45fab1e2ddf964e7eff7@o1223074.ingest.sentry.io/4504354854469632";

const config = () => {
    const env = environment[process.env.HOST];
    const version = process.env.version;

    return {
        googleMaps: env.googleMaps,
        api: {
            baseUrl: env.api.url,
            paths: {
                accounts: "/v1/accounts/",
                accountsList: "/v1/accounts-list/",
                altAssetBulkUpdate: "/v1/alt-asset-bulk-update/",
                altAssetReview: "/v1/alt-asset-review/",
                altAssets: "/v1/alt-assets/",
                assetFilter: "/v1/asset-filter/",
                assetFoundElsewhere: "/v1/asset-found-elsewhere/",
                assetList: "/v1/asset-list/",
                assetLookup: "/v1/asset-lookup/",
                assets: "/v1/assets/",
                assetControllers: "/v1/audit-controller-submission/",
                assetSync: "/v1/asset-sync/",
                assignmentDetails: "/v1/assignment-details/",
                auditArchive: "/v1/archive-audits/",
                auditAssetBulkUpdate: "/v1/audit-asset-bulk-update/",
                auditAssetNotes: "/v1/audit-asset-notes/",
                auditAssets: "/v1/audit-assets/",
                auditAssetStatus: "/v1/audit-asset-status/",
                auditAssignmentBulkUpdate: "/v1/audit-assignment-bulk-update/",
                auditAssignments: "/v1/audit-assignments/",
                auditAssignmentsOrg: "/v1/audit-assignments-org/",
                auditAbandonedClose: "/v1/audits/",
                auditClose: "/v1/audit-close/",
                auditComments: "/v1/audit-comments/",
                auditControllers: "/v1/audit-controller-submission/",
                auditGroups: "/v1/audit-groups/",
                auditGroupRecommendation: "/v1/audit-groups/recommended-group/",
                auditGroupStatus: "/v1/audit-group-status/",
                auditImages: "/v1/images/",
                auditLocations: "/v1/audit-locations/",
                auditResendAssignmentEmail: "/v1/resend-assignment-email/",
                auditReview: "/v1/audit-review/",
                audits: "/v1/audits/",
                auditsList: "/v1/audits/audits-list/",
                auditOrgRatingThresholds: "/v1/organisation-rating-thresholds/",
                auditRating: "/v1/audit-ratings/",
                auditRatingCategories: "/v1/audit-rating-categories/",
                auditRatingColors: "/v1/audit-rating-colors/",
                auditStatus: "/v1/audit-status/",
                auditSubmissions: "/v1/audit-submissions/",
                auditSummary: "/v1/audit-summary/",
                assetIotLookup: "/v1/asset-iot-lookup/",
                branchBulkUpdate: "/v1/branch-bulk-update/",
                branches: "/v1/branches/",
                branchList: "/v1/branch-list/",
                branchLocations: "/v1/branch-locations/",
                branchStockSummary: "/v1/branch-stock-summary/",
                createAccounts: "/v1/create-accounts/",
                deleteDealerContact: "/v1/dealer-contacts/delete-contact/",
                deleteUser: "/v1/delete-user/",
                exclusionReasons: "/v1/exclusion-reason-types/",
                financeTypes: "/v1/finance-types/",
                financeTypesList: "/v1/finance-types-list/",
                locationList: "/v1/location-list/",
                locations: "/v1/locations/",
                locationsGeoPoints: "/v1/location-geopoints/",
                locationAssetCount: "/v1/location-asset-count/",
                me: "/v1/me/",
                organisations: "/v1/organisations/",
                organisationSettings: "/v1/organisation-settings/",
                powerbi: "/v1/powerbi-token/",
                rotateImage: "/v1/images/orientate-image/",
                setPassword: "/v1/set_password/",
                typesList: "/v1/types-list/",
                uploads: "/v1/uploads/",
                uploadDetails: "/v1/upload-details/",
                uploadSignature: "/v1/upload-audit-signature/",
                userLocations: "/v1/user-locations/",
                userLanguage: "/v1/user-language/",
                userLocationsDelete: "/v1/user-locations-delete/",
                userOrganisations: "/v1/user-organisations/",
                userWelcomeRequest: "/v1/welcome-user-request/",
                validationErrors: "/v1/validation-errors/",
                validatedAuditAsset: "/v1/validated-asset-details/",
                vinDecoder: "/v1/vin-decoder/"
            }
        },
        asset: {
            maxValue: 2000000
        },
        assetSync: {
            timeout: 60000
        },
        auth: { ...env.auth, appClientId: env.clientId },
        allowedDistanceRange: env.allowedDistanceRange,
        pagination: {
            rowsPerPageOptions: [10, 20, 50, 100]
        },
        passwordReset: { ...env.passwordReset, clientId: env.clientId },
        paths: {
            altAssets: "alt-assets",
            allasset: "allasset",
            api: "api",
            assetFoundElsewhere: "asset-found-elsewhere",
            assets: "assets",
            audits: "audits",
            auth: "auth",
            signIn: "sign-in",
            branches: "branches",
            dashboard: "dashboard",
            manage: "manage",
            dataCheck: "datacheck",
            financeTypes: "finance-types",
            funderCheck: "funderCheck",
            groups: "groups",
            locations: "locations",
            login: "login",
            logout: "logout",
            organisations: "organisations",
            options: "options",
            reports: "reports",
            operations: "operations",
            settings: "settings",
            setup: "setup",
            uploadDownload: "upload-download",
            uploads: "uploads",
            users: "users",
            validationErrors: "validation-errors"
        },
        regex: {
            email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            escapeCharacters: /[.*+?^${}()|[\]\\]/g,
            split: /(?=[A-Z0-9])/
        },
        powerBI: env.powerBI,
        muiProKey: muiPro.key,
        version,
        sentryDsn,
        supportEmail: env.supportEmail,
        csvBox: env.csvBox
    };
};

export default config();

/** Keep this for Future reference */
// 1. uploads: "/v1/uploads/",
